import React from 'react';

// Components
import WpCheckbox from 'Wpds/components/checkbox/WpCheckbox';

type Props = {
  id: string;
  label: string;
  isChecked?: boolean;
  children?: React.ReactNode;
  onChange?(checked: boolean): void;
};

const FilterListItem = ({ id, label, isChecked = false, children, onChange }: Props) => {
  return <WpCheckbox id={id} label={label} component={children} checked={isChecked} onChange={onChange} />;
};

export default FilterListItem;
